export default "__VITE_ASSET___OU8tPDC__"